import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import {getPenguinsData} from "../../../../helpers";

const NewMembershipLoginModal = (props) => {
  const loginUrl = getPenguinsData(['view_data', 'shop_login_url']);
  return (
    <Dialog
      open
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Congratulations, your new DirectBuy membership is active!
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Username: <strong>{props.username}</strong><br/>
          Password: <strong>{props.password}</strong><br/>
          <a href={loginUrl} target="_blank">{loginUrl}</a>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <a href={loginUrl} target="_blank" style={{textDecoration: 'none'}}><Button color="primary" variant="contained" autoFocus>Login Now</Button></a>
      </DialogActions>
    </Dialog>
  );
};

NewMembershipLoginModal.propTypes = {
  classes: PropTypes.object,
  username: PropTypes.string,
  password: PropTypes.string
};

export default NewMembershipLoginModal;
